// this part overrides "close" method in MagnificPopup object
$.magnificPopup.instance.close = function () {
    
let footerEs = document.getElementById("shopify-section-footer");
let headerEs = document.getElementById("shopify-section-new-header");
let mainContent = document.getElementsByClassName("main-content");
    
	     footerEs.style.filter = "unset"
         headerEs.style.filter = "unset"
         mainContent[0].style.filter = "unset"
         
         $.magnificPopup.proto.close.call(this);
};